import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt, FaCheckCircle } from 'react-icons/fa';
import { Invoice } from '../../../types/invoice';
import { InvoiceStatus, InvoiceType } from '../../../types/enums';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

type OpenDeleteDialogFn = (invoice: Invoice) => void;
type MarkAsPaidFn = (invoice: Invoice) => void;

// دوال مساعدة لعرض الحالات بألوان
const renderInvoiceStatus = (status: InvoiceStatus) => {
  const styles: { [key in InvoiceStatus]: { color: string, text: string } } = {
    [InvoiceStatus.PENDING]: { color: 'orange', text: 'معلقة' },
    [InvoiceStatus.PAID]: { color: 'green', text: 'مدفوعة' },
    [InvoiceStatus.OVERDUE]: { color: 'red', text: 'متأخرة' },
    [InvoiceStatus.CANCELLED]: { color: 'gray', text: 'ملغاة' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

const renderInvoiceType = (type: InvoiceType) => {
    return type === InvoiceType.SERVICE ? 'خدمة' : 'اشتراك';
};

export const getInvoiceColumns = (openDeleteDialog: OpenDeleteDialogFn, markAsPaid: MarkAsPaidFn): ColumnDef<Invoice>[] => [
  {
    header: 'رقم الفاتورة',
    accessorKey: 'id',
  },
  {
    header: 'النوع',
    accessorKey: 'type',
    cell: ({ row }) => renderInvoiceType(row.original.type),
  },
  {
    header: 'الحالة',
    accessorKey: 'status',
    cell: ({ row }) => renderInvoiceStatus(row.original.status),
  },
  {
    header: 'المبلغ',
    accessorKey: 'amount',
    cell: ({ row }) => `${row.original.amount} ر.س`,
  },
  {
    header: 'تاريخ الاستحقاق',
    accessorFn: (row) => new Date(row.due_date).toLocaleDateString('ar-EG'),
  },
  {
    header: 'تاريخ الدفع',
    accessorFn: (row) => row.payment_date ? new Date(row.payment_date).toLocaleDateString('ar-EG') : '—',
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const invoice = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          {invoice.status === InvoiceStatus.PENDING && (
            <button onClick={() => markAsPaid(invoice)} className={`${pageStyles.actionButton} ${pageStyles.approve}`} title="تحديد كمدفوعة">
              <Icon as={FaCheckCircle} style={pageStyles.icon } />
            </button>
          )}
          <Link to={`/admin/invoices/edit/${invoice.id}`} className={`${pageStyles.actionButton} ${pageStyles.edit}`} title="تعديل">
            <Icon as={FaEdit} style={pageStyles.icon } />
          </Link>
          <button onClick={() => openDeleteDialog(invoice)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
             <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
